module.exports = __webpack_public_path__ + "img/ИФ-1(А)-049-m.c745761b.png";